import React from 'react';



type Props = {
  className?: string;
}
export const CheckCircleVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M8.5 12.5L10.5 14.5L15.5 9.5' />
    </svg>
  );
};
